export { default } from './generateUtilityClass';
export * from './generateUtilityClass';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/generateUtilityClass/index.js
// module id = 5
// module chunks = 25